<header class="relative container z-50" id="header">
    <div class="absolute lg:top-8 top-7 left-0 z-20 w-full xl:px-12 xs:px-10 px-5 flex items-center justify-between">
        <img [src]="logoSelectorSrc()" alt="Receeto logo" routerLink="/" class="rc2-logo">

        <ul [ngClass]="{
            'lg:flex hidden xl:gap-10 gap-7 xl:ml-[60px] ml-[50px] rounded-[40px] xl:px-10 xl:py-4 px-9 py-3.5 [&>li>a]:text-[15px] [&>li>a]:font-semibold ': true,
            'bg-black/10 [&>li>a]:text-white [&>li>a]:hover:text-black': (currentUrl() === '/' && !this.isLoading()),
            '[&>li>a]:text-black [&>li>a]:hover:text-primary': (currentUrl() !== '/' || this.isLoading())
        }">
            <li><a routerLink="/shoppers" routerLinkActive="!text-primary">Shoppers</a></li>
            <li><a routerLink="/sellers" routerLinkActive="!text-primary">Sellers</a></li>
            <li><a routerLink="/partners" routerLinkActive="!text-primary">Partners</a></li>
            <li 
                (mouseenter)="dropdownMenuOpened.set('flex')" 
                (mouseleave)="dropdownMenuOpened.set('hidden')"
                class="relative inline-block dropdown-menu"
            >
                <a [ngClass]="{ 
                    'relative inline-flex items-center gap-1 ': true,
                    '!text-primary': isRouterLinkActive 
                }">
                    To know
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 1024 1024">
                        <path fill="currentColor" d="M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8l316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496"/>
                    </svg>
                </a>
                <div [class]="`${dropdownMenuOpened()} dropdown-menu-content pt-2.5 absolute`">
                    <div class="min-w-[140px] flex flex-col items-start bg-white rounded-md border-t-2 border-primary shadow-md z-10 [&>button]:!h-[40px] [&>button]:!justify-start [&>button]:!rounded-md [&>button]:!text-sm [&>button]:!text-black/85 [&>button]:!font-semibold [&>button]:!w-full [&>button]:!p-2.5 [&>button]:!focus:bg-primary-container/50 [&>button]:!hover:bg-primary-container/50">
                        <button mat-button routerLink="/about-us" (click)="dropdownMenuOpened.set('hidden')">About Us</button>
                        <button mat-button routerLink="/blogs" (click)="dropdownMenuOpened.set('hidden')">Blogs</button>
                    </div>
                </div>
            </li>
            <li><a routerLink="/contact-us" routerLinkActive="!text-primary">Contact us</a></li>
        </ul>

        <button mat-flat-button class="max-lg:!hidden" routerLink="/login">Log In</button>
        
        <button mat-icon-button (click)="toggleSidenav()" [ngClass]="{
            'lg:!hidden !block ': true,
            '[&>svg]:!text-white': (currentUrl() === '/' && responsiveService.mediumWidth() && !this.isLoading())
        }">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="text-on-surface-variant">
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M3 6h18M3 12h18M3 18h18"/>
            </svg>
        </button>
    </div>
</header>